export default "__VITE_ASSET__Cjcu94GP__"